// add your site specific javascript here
window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
window.mobileAndTabletCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
(function ( $ ) {
	'use strict';

	$.ajaxSetup( {
		cache: true
	} );

	
	//For crawler
	if ( !window.JS_ENABLED ) {
		$.ajax( {
			url:      window.makeUrl( { module: 'eshop', action: 'setJavascriptEnabled' } ),
			type:     'post',
			dataType: 'json'
		} );
	}
	// -----------------------------------------------------------------------------------------------------------------
	// Anything to be initialized on document ready goes here

	$( function () {
		//menu mobile
		
		$('#navbar-collapse-categories-mobile [data-toggle="collapse"]').on('click',function(e){
			e.stopPropagation();
			if(!$(this).hasClass('collapsed')){
				e.preventDefault();
				$(this).addClass('collapsed');
				$(this).next().removeClass('in');
			}
			
		});
		
		
		//DISABLE PARALLAX FOR SAFARI
		var is_safari = (navigator.userAgent.indexOf('Safari') != -1) && (navigator.userAgent.indexOf('Chrome') == -1);
		if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) || is_safari) {
			$(".dropdown-toggle").mouseover(function(e) {
          e.stopPropagation();
			});
		}
		
		//First modal registration
		$( '#registrationModalThanks').modal( 'show' );

		// If we have an "active" tab we start with that one selected, otherwise we select the first one
		$( '.nav-tabs' ).each( function () {
			var $activeTab = $( this ).find( '.active [data-toggle="tab"]:first' );

			if ( $activeTab.length ) {
				$activeTab.tab();
			} else {
				$( this ).find( '[data-toggle="tab"]:first' ).tab();
			}
		} );

		
		// Animated Hamburger Icon, Open and Close navMobile
		$('#nav-icon').click(function(e){
			$('#navbar-collapse-categories-mobile').click(); //Element clicked to trigger the below function that will close the menu automatically when a user clicks outside of it
			e.preventDefault();
			e.stopPropagation();
			$(this).toggleClass('open');
			//$('.main-logo-container').toggleClass('open');
			
			var menuStatus = $('.navMobile').css('left');
			if(menuStatus=='-285px')
			{
				/*open*/
				$('.navMobile').animate({
					'left':'0'
				},'fast');
				$('.main-logo-container-fixed').animate({
					'left':'65px',
					'margin-left':'0',
					'opacity':'1'
				},'fast');
				$('.main-logo-container>a>img.main-logo').animate({
					'margin-left': '-134px',
					'opacity':'0'
				},'fast');
			}
			else
			{
				/*close*/
				$('.navMobile').animate({
					'left':'-285px'
				},'fast');
				$('.main-logo-container-fixed').animate({
					'left':'50%',
					'margin-left':'-48px',
					'opacity':'0'
				},'fast');
				$('.main-logo-container>a>img.main-logo').animate({
					'margin-left': '0',
					'opacity':'1'
				},'fast');
			}
		});
		
		$('#nav-icon-close').click(function(e){
			e.preventDefault();
			e.stopPropagation();
			$('#nav-icon').removeClass('open');
			//$('.main-logo-container').toggleClass('open');
			var menuStatus = $('.navMobile').css('left');

			if(menuStatus=='0px')
			{
				$('.navMobile').animate({
					'left':'-285px'
				},'fast');
				$('.main-logo-container-fixed').animate({
					'left':'50%',
					'margin-left':'-48px',
					'opacity':'0'
				},'fast');
				$('.main-logo-container>a>img.main-logo').animate({
					'margin-left': '0',
					'opacity':'1'
				},'fast');
			}
			else
			{
				$('.navMobile').animate({
					'left':'0'
				},'fast');
				$('.main-logo-container-fixed').animate({
					'left':'65px',
					'margin-left':'0',
					'opacity':'1'
				},'fast');
				$('.main-logo-container>a>img.main-logo').animate({
					'margin-left': '-134px',
					'opacity':'0'
				},'fast');
			}
		});
		//
		
		
		
		// Code to close automatically the mobile menu when the user clicks outside of it
		$(document).mouseup(function(e) 
		{
			var valueLeftNavMobile = $('[data-zg-role="navMobile"]').css('left');
				
			// It will only be closed when the navMobile is opened
			if( valueLeftNavMobile == "0px" ){
					var container = $('#navbar-collapse-categories-mobile');

					// if the target of the click isn't the container nor a descendant of the container
					if (!container.is(e.target) && container.has(e.target).length === 0) 
					{
							$('#nav-icon-close').click();
					}
			}
		});
		
		
		
		// navMobile scroll event
		$( '.navMobile' ).scroll(function() {
			var scrollPos = $('.navMobile').scrollTop();
			if (scrollPos > 1){  
				$('.main-logo-container-fixed').removeClass("visible-xs");
				$('.main-logo-container-fixed').addClass("hidden");
				$('#nav-icon-close').css("display","none");
			}
			else{
				$('.main-logo-container-fixed').removeClass("hidden");
				$('.main-logo-container-fixed').addClass("visible-xs");
				$('#nav-icon-close').css("display","block");
			}	
		});
		
		
		// stiky header
		$(window).scroll(function() {
			var scrollPos = $(document).scrollTop();
			if (scrollPos > 1){  
				$('body.page_home').addClass("sticky");
				$('a.dropdown-toggle').removeClass("white");
			}
			else{
				$('body.page_home').removeClass("sticky");
				$('a.dropdown-toggle').addClass("white");
			}	
		});
		
		// Open close tab-pane mobile
		$('.closeTab').click(function(e){
			$('.tabbable .nav li').removeClass('active');
			$('.tabbable .tab-content .tab-pane').removeClass('active');
		});
		
		// Toggle div for address in Account manager
		$(document).on("click", ".openAddress" , function() {
			$(".closeTab").css('display','none!important')
			$(".dynAddress").css('display','block');
			$(".addressList").css('display','none');
		});
		$(document).on("click", ".dynAddress .btn-back" , function() {
			$(".closeTab").css('display','block')
			$(".dynAddress").css('display','none');
			$(".addressList").css('display','block');
		});
		
		
		// Reset form
		$("#resetForm").click(function(){ 
			$("#addressFormNoModal")[0].reset();
		});
		
		// Select Refund/Change product, get the value from a checked checkbox
		$(".inputCheckbox").click( function(){
			var elementId = $(this).attr('id').slice(-1);
			var selectOpt = ("select.sel-" + elementId);
			
			if( $(this).is(':checked') ){
				if ( $(this).val() == 1 ){
					//refund
					$( selectOpt ).val("refund").change();
				} else {
					//exchange
					$( selectOpt ).val("exchange").change();
				}
			} else {
				$( selectOpt ).val("").change();
			}
		});
		
	
	// Carousel Settings - Home
	$( '.carousel' ).carousel( {} );
			// SWIPE CAROUSEL
			var $carousel = $( '.carousel' );
			if ( $carousel.length ) {
					$carousel.swiperight( function () {
							$( this ).carousel( 'prev' );
					} );
					$carousel.swipeleft( function () {
							$( this ).carousel( 'next' );
					} );
			}
	} );

	$( function () {
		$( this ).find( '[data-zg-role="search-input"]').each( function(){
				//Bind the search function
				$( this ).on('input paste', function(){


					// Retrieve the input field text and reset the count to zero
					var filter = $(this).val(), count = 0;

					// Loop through the comment list
					$('[data-zg-role="search-items"]').each(function(){

						// If the list item does not contain the text phrase fade it out
						if ($(this).text().search(new RegExp(filter, "i")) < 0) {
							$(this).fadeOut();

							// Show the list item if the phrase matches and increase the count by 1
						} else {
							$(this).show();
							count++;
						}
					});

					// Update the count
					if(count > 0){
						$("#noResult").addClass('hide');
					}
					else{
						$("#noResult").removeClass('hide');
					}
					$("#filter-count").text(count);
					$(".count-hide").removeClass('hide');

				});
			}
		);

	});

	//Scroll slowly to the target
	$( function () {
		$('[data-zg-scrollTo="slowly"]').click(function (e) {
			e.preventDefault();
			var target = $(this).data('zg-target');
			var top=$(target).offset().top;
			if($('.manager_category').length !==0 || $('.manager_product').length !==0){
		
				top=top-100;
			}
			if($('.manager_home').length !==0){
				top=0;
			}
			//console.log(top);
			
			//href = $(this).attr("href");
			$('html, body').animate({scrollTop: top}, 1000);
			
			//window.location.hash = href;
		});
		
	});
	
	
	
	
	//START: CUSTOM AFFIX CODE
	//The idea is to set fixed the $productFixedContainer when this element reaches the top of the page. 
	//It will be set as relative when $relatedProducts shows up from the bottom of the screen (when the user scrolls down) and set back fixed if the user scrolls up again.
	//Code to check if an element is visible in viewport taken from here: https://stackoverflow.com/questions/20791374/jquery-check-if-element-is-visible-in-viewport/33979503#33979503
	
	var $productFixedContainer = $( "[data-zg-role='product-options-fixed']" );
	var windowScrollTop = 0;
	var heightHeader = 114;
	var $relatedProducts = $("#related-products");
	//$( "[data-zg-role='product-options-fixed']" ).width($('.table-product .right').width());
	$productFixedContainer.width(($(document).width()/10*4) -136);
	$productFixedContainer.css( 'position', 'relative' );
	$productFixedContainer.css( 'top', '114px' );
	
	//The purpose of this "flag" is to only set only once the CSS top value to the fixedContainer only when $relatedProducts shows up from the bottom of the page.
	//If the user scrolls up and $relatedProducts dissapears again, then, the flag is enabled again
	var flag = true; 
	
	if( $productFixedContainer.length && !IS_MOBILE ){
		$(window).scroll(function(e){
			windowScrollTop = $(window).scrollTop();
			if( windowScrollTop > heightHeader ){
				$productFixedContainer.addClass( 'custom-affix' );
			}

			var extraPaddingAdded = 400; //Value modified according to the space that needs to be added in the top of the YMAL products so that the Affix feature will work properly
			var top_of_element = $relatedProducts.offset().top - extraPaddingAdded;
			var bottom_of_element = $relatedProducts.offset().top + $(window).innerHeight();//$relatedProducts.outerHeight();
			var maxScrollTop = top_of_element - $productFixedContainer.innerHeight();
			var maxTop=bottom_of_element - $productFixedContainer.innerHeight();
			//console.log(maxScrollTop);
			//console.log(windowScrollTop);
			if (maxScrollTop<= windowScrollTop && maxScrollTop >0){

					$productFixedContainer.css( 'position', 'relative' );
					$productFixedContainer.css( 'top', maxScrollTop );
			} else {
				$productFixedContainer.css( 'position', 'fixed' );
				$productFixedContainer.css( 'top', heightHeader );

			}
		});
		/*$('.collapse-prod-description .collapse').on('show.bs.collapse',function(e){
			
			setTimeout(function(){
				$productFixedContainer.css( 'transition', 'all .6s' );
				$(window).scroll();
			},200);
		});*/
		$('.collapse-prod-description .collapse').on('shown.bs.collapse',function(e){
			$productFixedContainer.css( 'transition', 'all .8s' );
			$(window).scroll();
			setTimeout(function(){
				$productFixedContainer.css( 'transition', 'none' );
			},1000);
		});
	}
	
	$(window).scroll();
	//END: CUSTOM AFFIX CODE
		

	
	$(window).scroll(function(e){
		var $el = $('.onTop'); 
		if ($(this).scrollTop() > 300){ 
			$el.removeClass('hidden'); 
		}
		if ($(this).scrollTop() < 300)
		{
			$el.addClass('hidden'); 
		} 
		if($('.product-bar').length){
			var $bar = $('.product-bar'); 
			if ($(this).scrollTop() > 300){ 
				$bar.addClass('up'); 
			}
			if ($(this).scrollTop() < 300)
			{
				$bar.removeClass('up'); 
			}
		}
		if($('.checkout-fixed').length){
			var $barcheckout = $('.checkout-fixed'); 
			if ($(this).scrollTop() > 100){ 
				$barcheckout.addClass('up'); 
			}
			if ($(this).scrollTop() < 100)
			{
				$barcheckout.removeClass('up'); 
			}
		}
	});
	

	// Mobile header scroll up and down
	$(function(){
			//Keep track of last scroll
			var lastScroll = 0;
			$(window).scroll(function(event){
					//Sets the current scroll position
					var st = $(this).scrollTop();
					//Determines up-or-down scrolling
					if (st > lastScroll){
						$(".headerMobile").removeClass("fixed");
						//$(".manager_account #site_main").removeClass("paddingTop");
					} 
					else {
						$(".headerMobile").addClass("fixed");
						//$(".manager_account #site_main").addClass("paddingTop");
					}
					//Updates scroll position
					lastScroll = st;
			});
   });
	
	
	$('.input_email').on( "focus", function(){
		$('.newsletter_block .input-group-btn').removeClass('hidden');
		$('.newsletter_block .checkbox').removeClass('hidden');
	});
	
	//STICKY HEADER CHANGE BG
	var $stickyHeader=$('#site_header');
	var main_banner=false;
	
	// SET BANNER 100% HEIGHT
	function setImageBanner(){
		var $docHeight =  $( window ).height();
		$('.main_banner').css('height',$docHeight);
		
	}
	if($('.main_banner').length && $('.banner-exchange').length == 0){
		setImageBanner();
		main_banner=true;
	}
	function mainBanner(){
		if(main_banner){			
			var sticky = $('.main_banner').height();//+$stickyHeader.height();
			 if (window.pageYOffset > sticky) {
					$stickyHeader.addClass('white');
			}else{
				$stickyHeader.removeClass('white');
			}
		}else{
			if (window.pageYOffset > 0) {
				$stickyHeader.addClass('white');
			}else{
				$stickyHeader.removeClass('white');
			}
		}
	}
	$(window).scroll(function() {
		mainBanner();
	});
	
	$( window ).resize(function() {
		if($('.main_banner').length){
			setImageBanner();
		}
		
	});
	$(document).ready(function(){
			mainBanner();
	});
	$('#typeahead-search-button').on('click',function(e){
		if($('#product-finder .close').length){
				e.preventDefault();
				$('#product-finder .close').removeClass('close');
		}
	});
	// SEARCH MOBILE
	$('#typeahead-search-button-mobile').on('click',function(e){
		if($('#product-finder .close').length){
				e.preventDefault();
				$('#product-finder .close').removeClass('close');
		}
	});
	$('#searchToggle').on('click',function(e){
		$('.headerMobile').toggleClass('bkgWhite');							
		$('#searchForm').toggle('slow', function() {
			// complete
		});									
	});
	$( document ).on('[data-zg-role="reset-filters"]','click', function(){
			$( document ).trigger('zg.filter.applyFilters');
	});
	//ON CART LOAD AND WISH
	$( document ).on( 'zg.getProductList.updated',function(){
		//console.log($('[data-zg-collapse="collapse"]').length);
		$('[data-zg-collapse="collapse"]').on('click', function(e){
			e.preventDefault();
			e.stopPropagation();
			$(this).addClass('hidden')
			$('.'+$(this).attr('data-zg-target')).removeClass('hidden');
		});
	});
})( jQuery );
// -----------------------------------------------------------------------------
// STORE LOCATOR LIST
// HIDE RESULTS IF NO FILTERS ARE APPLIED

(function ($) {
    'use strict';
	$(document).on('click','#sl-container [data-zg-role="reset-filters"]',function(e){
		setTimeout(function(){
			$( document ).trigger( 'storeReset');
		},800);
	});
	$(document).on('focus','#store-locator [data-zg-role="filter-search"]',function(e){
		$('[data-zg-role="filter-search"]').val('')
	});

    $(function () {
        var $filtersStores = $('#sl-filter-container');
        var $paginationStores = $('#sl-stores-container');

        $filtersStores.on('applyFilters', function (e, appliedFilters) {
            if (Object.keys(appliedFilters).length >= 1 ||  $('[data-zg-role="filter-search"]').val().length !=0) {
                $paginationStores.removeClass('hidden');
            } else {
                $paginationStores.addClass('hidden');
            }
        });
    });
})(jQuery);

$( document ).on( 'applyFilters',function(){
	//console.log("applyFilters");
	if($('[data-zg-role="selected-filter"]').length){
		$( '[data-zg-role="selected-filter"]' ).text('');
		$('#filter-container .content-filter .active').each(function(){
			if($(this).data('zg-action')!== "reset"){
				var $this=$(this).clone();
				var $t=$(this);
				$( '[data-zg-role="selected-filter"]' ).append( $this );
				$this.on('click',function(e){
					e.preventDefault();
					e.stopPropagation();
					$t.click();
				});
			}
		});
		// data-role="rangeslider" #range-1a #range-1b (min max value)
		if(
			$('[data-role="rangeslider"] #range-1a').attr('min') !==  $('[data-role="rangeslider"] #range-1a').attr('value') || 
			$('[data-role="rangeslider"] #range-1b').attr('max') !==  $('[data-role="rangeslider"] #range-1b').attr('value') 
			){
				/*var ram = $('[data-role="rangeslider"] #range-1a').attr('min'),
				rav = $('[data-role="rangeslider"] #range-1a').attr('value'),
				rbm = $('[data-role="rangeslider"] #range-1b').attr('max'),
				rbv = $('[data-role="rangeslider"] #range-1b').attr('value');
				var min = ram !== rav ? rav : ram;
				var max = rbm !== rbv ? rbv : rbm;
				console.log(min);
				console.log(max);
				*/
				var $filterPrice='<a class="txt-filter price-filter">'+$('[data-role="rangeslider"] #range-1a').attr('value')+' - '+$('[data-role="rangeslider"] #range-1b').attr('value')+'</a>' ;
				$( '[data-zg-role="selected-filter"]' ).append( $filterPrice );
				$('.price-filter').on('click',function(){					
					$('[data-role="rangeslider"]').trigger('reset');
				});
				$('.selected-filter').removeClass('hidden');
				var $delete='<div class="visible-xs removeAllFilters pull-right">x</div>';				
				$( '[data-zg-role="selected-filter"]' ).append( $delete );
				$('.removeAllFilters').on('click',function(){
					$('.selected-filter a').each(function(){
						$(this).trigger('click');
					});
				});
		}else{
			if($('#filter-container .filter.panel .content-filter .active').not('[data-zg-action="reset"]').length===0){
				$('.selected-filter').addClass('hidden');
			}else{
				$('.selected-filter').removeClass('hidden');
				var $delete='<div class="visible-xs removeAllFilters pull-right">x</div>';
				$( '[data-zg-role="selected-filter"]' ).append( $delete );
				$('.removeAllFilters').on('click',function(){
					$('.selected-filter a').each(function(){
						$(this).trigger('click');
					});
				});
			}			
		}
	}else{
		$('.selected-filter').addClass('hidden');				
	}
	
});

/*to close the options when click out*/
$(document).mouseup(function (e) {
   if (!$('.product-filters').is(e.target) // if the target of the click isn't the container...
   && $('.product-filters').has(e.target).length === 0) // ... nor a descendant of the container
   {
     $('.product-filters').parent('.btn-group-toggle').find('[data-zg-role="selected-single-combination"]').not('.collapsed').click();
  }
 });
//MINIBAR AND main option on product page LINKED
$('.manager_product').on('click','.product-options [data-value]',function(e, isTriggered){
	//ADD THE CHANGE OF BIGZOOM
	$('[data-zg-role="thumbnail-zoom"]').first().addClass('selected');
	var selectedBkg = $('[data-zg-role="thumbnail-zoom"]').first().attr('data-zoom-images');
	$('[data-zg-role="big-zoom"]').css('background-image', 'url('+ selectedBkg +')');
	//CHANGE MINIBAR IMAGE
	$('.product-bar .img-responsive').attr('src',selectedBkg.replace('_big','_cart'));
	
	//END
	if (!isTriggered){
		var $t=$(this);
		var val=$(this).attr('data-value');
		$('.product-options [data-value="'+val+'"]').not($(this)).each(function(){
			if($(this)!==$t && !$(this).hasClass('active')){
				$(this).trigger('click',[true]);
			}
		});
	}
	
});

$( function () {	
	if ( !$( '#modalSizeChart' ).length )
		return false;

	function loadSizechart ( categories ) {
		var $container = $('#modalSizeChart .modal-body');
		var	sizechartfilter = categories || 0;


		var	url = window.makeUrl( { module: 'eshop', manager: 'cms', action: 'list', type: 'new_size_guide', master : 'master_blank' } );

		if ( categories ) {
			
			url = window.makeUrl( { module: 'eshop', manager: 'cms', action: 'list', type: 'new_size_guide', sizechartFilterBy: sizechartfilter , master : 'master_blank' } );
		}

		$.ajax({
			url: url,
			cache: false,
			dataType: "html",

			beforeSend: function ( xhr ) {
				xhr.setRequestHeader('X-Requested-With', 'empty');
				$container.empty().addClass('loading-secondary');
			},

			success: function ( responseText ) {
				$container.empty().append( responseText );
			},

			complete: function () {
				$container.removeClass('loading-secondary');
			}
		});
	}

	$( document ).on( 'click', '[data-sizechart-categories]', function(e){
		var categories = $(this).data('sizechart-categories');
		loadSizechart( categories );
	});


	// Swap Show more/less button text
	$( '[data-zg-role="show-more-less"]').click( function( e ){
		if( $( this ).hasClass( 'collapsed') ){
			$( this ).find( '[data-zg-role="show-more-btn"]' ).addClass( 'hidden' );
			$( this ).find( '[data-zg-role="show-less-btn"]' ).removeClass( 'hidden' );
		}
		else {
			$( this ).find( '[data-zg-role="show-more-btn"]' ).removeClass( 'hidden' );
			$( this ).find( '[data-zg-role="show-less-btn"]' ).addClass( 'hidden' );
		}
	});

} );



// register page
if ( $('[data-zg-role="register-area"]').length ) {
	$('[data-zg-role="register-area"]').hide();
	$('[data-zg-role="guest-area"]').hide();
	$(document).on("click",'[data-zg-role="register-btn"]',function(e) {
			e.preventDefault();
			$('[data-zg-role="login-area"]').hide();
			$('[data-zg-role="register-area"]').show();
	});

	$(document).on("click",'[data-zg-role="guest-btn"]',function(e) {
			e.preventDefault();
			$('[data-zg-role="login-area"]').hide();
			$('[data-zg-role="guest-area"]').show();
	});

	$(document).on("click",'[data-zg-role="back-register"]',function(e) {
			e.preventDefault();
			$('[data-zg-role="login-area"]').show();
			$('[data-zg-role="register-area"]').hide();
	});

	$(document).on("click",'[data-zg-role="back-guest"]',function(e) {
			e.preventDefault();
			$('[data-zg-role="login-area"]').show();
			$('[data-zg-role="guest-area"]').hide();
	});
}

if ( $('.input-group input,.input-group textarea,.input-group select').length ) {
	$(document).on("focus", '.input-group input,.input-group textarea,.input-group select',function(e) {
		$(this).closest( ".input-group" ).addClass('focused');
	});
	
}	


function colorHeaderMenu(){
	//console.log('header menu color');
	var docViewTop = $(window).scrollTop();
	var mainBannerHeight=$('.main_banner ').height()-100;
	var colorMenu=$('.main_banner').data('colorMenu');
	var colorHeader=$('.main_banner').data('colorHeader');
	if($('.main_banner .item').length){
		colorMenu=$('.main_banner .item.active').data('colorMenu') ? $('.main_banner .item.active').data('colorMenu')  : '';
	}
	if($('.main_banner .item').length){
		colorHeader=$('.main_banner .item.active').data('colorHeader') ? $('.main_banner .item.active').data('colorMenu')  :  '';
	}
	if(docViewTop>=mainBannerHeight){
		$('#navbar-collapse-categories a').css('color','');		
		$('#navbar-collapse-main .navbar-right > li > a').css('color','');
		$('#site_header .navbar-default #navbar-collapse-main>.navbar-right>.form-group>input').css('color','');
		$('.ico-black').removeClass('hidden');
		$('.ico-white').addClass('hidden');
		if($('.cart-red').hasClass('hidden')){
			$('.cart-black').removeClass('hidden');
			$('.cart-white').addClass('hidden');
		}
		$('.navbar-brand').removeClass('hidden');
		$('.navbar-brand.white').addClass('hidden');
		$('.left-menu-sticky').removeClass('white');
	}else{
		if(colorHeader !== undefined){
			if(colorHeader.toUpperCase()=== "#FFF" || colorHeader.toUpperCase()=== "#FFFFFF"){
				$('.ico-white').removeClass('hidden');
				$('.ico-black').addClass('hidden');
				if($('.cart-red').hasClass('hidden')){
					$('.cart-black').addClass('hidden');
					$('.cart-white').removeClass('hidden');
				}
				$('.navbar-brand').addClass('hidden');
				$('.navbar-brand.white').removeClass('hidden');	
				$('.left-menu-sticky').addClass('white');				
			}else{			
				$('.navbar-brand').removeClass('hidden');
				$('.navbar-brand.white').addClass('hidden');
				$('.left-menu-sticky').removeClass('white');
			}

			if(colorHeader.toUpperCase()=== "#000" || colorHeader.toUpperCase()=== "#000000"){
				$('.ico-black').removeClass('hidden');
				$('.ico-white').addClass('hidden');
				if($('.cart-red').hasClass('hidden')){
					$('.cart-white').addClass('hidden');
					$('.cart-black').removeClass('hidden');
				}
				$('.navbar-brand').removeClass('hidden');
				$('.navbar-brand.white').addClass('hidden');
			}
		}
		
		$('#navbar-collapse-categories a').css('color',colorMenu);
		$('#navbar-collapse-main .navbar-right > li > a').css('color',colorHeader);
		$('#site_header .navbar-default #navbar-collapse-main>.navbar-right>.form-group>input').css('color',colorHeader);
	}
}
function isScrolledIntoView(elem)
{
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top+150;
    var elemBottom = elemTop + $(elem).height()-150;
		//ALL VISIBLE
    //return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		//TOP VISIBLE
		return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
}
function ueImage(){
	//.banner_images img,
	//.double_images img,.category_double_images img
	$('.double_images img,.category_double_images img ').each(function(  ){
		var t=200;
		$(this).not('.ue-done').each(function( ){
			if(isScrolledIntoView($(this))){
					$(this).addClass('ue-done');
				$(this).removeClass('not-visible');
			}else{
				$(this).addClass('not-visible');
			}
		});
	});
}


$(document).ready(function(){
	if($('.manager_home').length == 0){
		ueImage();
	}
	if ($('.main_banner').length > 0 || $('.type_page_search_store').length > 0){
		colorHeaderMenu();
		$('#mainCarousel').bind('slid.bs.carousel',function(){
		colorHeaderMenu();
		});
	}
});
$(window).scroll(function() {
	if($('.manager_home').length == 0){
		ueImage();
	}
	if ($('.main_banner').length > 0 ){
		colorHeaderMenu();
	}
});


// Closing the Product page options when the user select them
$( document ).on( 'zg.product.optionUpdated', function(){
	$( '[data-zg-role="option-selector"]' ).find( 'a' ).click( function(){ 
			var collapseMenu = this.closest( '.collapse.in' );
			if( collapseMenu ){
				$( '#' + collapseMenu.id ).collapse( 'toggle' );
			}
	});
});

// ############################################
// ########## VIDEO FULLSCREEN TRICK ##########
// ############################################

function videoSize() {
  var $windowHeight = $(window).height();
  var $videoHeight = $(".video").outerHeight();
	var $scale = $windowHeight / $videoHeight;
  
  if ($videoHeight <= $windowHeight) {
    $(".video").css({
      "-webkit-transform" : "scale("+$scale+") translateY(-50%)",
			"transform" : "scale("+$scale+") translateY(-50%)"
		});
	};
}

$(window).on('load resize',function(){
  videoSize();
});





// ############################################
// ############### PRODUCT ZOOM ###############
// ############################################

var selectedThumbnail = '[data-zg-role="thumbnail-zoom"]';
var containerBig = '[data-zg-role="big-zoom"]';
var openZoomMobile = '[data-zg-role="zoom-open"]';

// Zoom mobile
$(document).on('click', openZoomMobile ,function(){
  var selectedBkg = $(this).attr('data-zoom-images');
	$(containerBig).css('background-image', 'url('+ selectedBkg +')');
	$(containerBig).css('background-position', 'center,center');
	$('.product-zoom').css('display','block');
	$('.product-bar').addClass('up');
});
//

$('#zoomMain img').click(function(e){
	// intercetta l'immgine che va nello zoomMain e apri il product-zoom con quella
	var selectedMain = $(this).attr('src');
	$(containerBig).css('background-image', 'url('+ selectedMain +')');
	$('.product-zoom').css('display','block');
	$('.product-bar').addClass('up');
	$('.table-product').css('display','none');
	$('.suggestedProducts').css('display','none');
	$('.newsletter_block').css('display','none');
	
	//ADD CORRECT SELECTED THUMB
	$('.btn-thumbnail').each(function(){
		if($(this).attr('data-zoom-images')==$('.thumbnail.active').attr('data-images')){
			$(this).trigger('mouseover');
		}
	});
	
});

$('.zoom-close').click(function(e){
	$('.product-zoom').css('display','none');
	$('.product-bar').removeClass('up');
	$('.table-product').css('display','block');
	$('.suggestedProducts').css('display','block');
	$('.newsletter_block').css('display','block');
});

$(document).on('mouseover', selectedThumbnail ,function(){
  var selectedBkg = $(this).attr('data-zoom-images');
	$('.btn-thumbnail').removeClass('selected');
	$(this).addClass('selected');
	$(containerBig).css('background-image', 'url('+ selectedBkg +')');
});


$('.zoom-img-container').on( "mousemove ", function( e ) {
	e.preventDefault();
	e.stopPropagation();
	var eventY = e.pageY;
	var docHeight =  $( window ).height();
	var positionY = (eventY / docHeight) * 100;
	$(this).css('background-position-y', positionY + '%');
});
var touchZoom = false;
$( ".zoom-img-container" ).bind('touchstart', function (e){
   //ts = e.originalEvent.touches[0].clientY;
	//console.log('start');
	touchZoom = true;
});

$( ".zoom-img-container" ).bind('touchend', function (e){
	touchZoom = false;
	//console.log('stop');
});
$( ".zoom-img-container" ).bind('touchmove', function (e){
	if(touchZoom){
		var currentY = e.originalEvent.touches[0].clientY;
		var currentX = e.originalEvent.touches[0].clientX;

		lastY = currentY;
		var eventY = e.pageY;
		var docHeight =  $( window ).height();
		var positionY = (currentY / docHeight) * 100;
		$(this).css('background-position-y', positionY + '%');
		var positionX = (currentX / docHeight) * 200;
		$(this).css('background-position-x', positionX + '%');
	}
});
/*$('.zoom-img-container').on( "swipe.up", function( e ) {

 	
	console.log(e);
});*/

function handleTouchMoveImage(evt) {
    if ( ! xDown || ! yDown ) {
        return;
    }

    var xUp = evt.touches[0].clientX;                                    
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;


        if ( yDiff > 0 ) {
					/* up swipe */ 					
					//console.log('scroll touch');
					var r=scrollToNext();
					setTimeout(function() {
							onScrolling = false;
					}, 1000);
        } else { 
					/* down swipe */
					//console.log('scroll touch');
					var r=scrollToPrev();
					setTimeout(function() {
							onScrolling = false;
					}, 1000);
					
					
        }                                                                 

    /* reset values */
    xDown = null;
    yDown = null;                                             
};

$(document).on('click', '[data-zg-role="scroll-to"]' ,function(){
  var id = $(this).data('id');
	var classId = $(this).data('class');
	if(classId){
		$('html,body').animate({
    	scrollTop: $('.'+ classId).offset().top-150
  	},'slow');
	}
	if(id){
		$('html,body').animate({
    	scrollTop: $('#'+id).offset().top-150
  	},'slow');
	}
});
$(document).on('focus', '[name="frmEmail"]' ,function(){
	//console.log('chenge');
	if($('.checkbox.collapse')){
		//console.log('collapse on');
		$('.checkbox.collapse').addClass('in');
	}
});


$(document).on('submit', '[data-zg-role="landing-newsletter"]' ,function(e){
	
	if( $(this).find('#frmEmail').val() == '' || $(this).find('[name="check-page"]').prop('checked') == false){
		
		if($(this).find('#frmEmail').val() == '') $(this).find('#frmEmail').focus();
		
	 return false;
	}
	
});
/*SCRIPT to close macro category opened via html*/
var timeoutMenu;
//if in main category page
if($('.main-category-menu').length != 0){
	timeoutMenu=setTimeout(function(){
		$('.category-menu').removeClass('on');
	},1500);
}
$('#navbar-collapse-categories').mouseenter(function() {
	clearTimeout(timeoutMenu);
});
$('#navbar-collapse-categories').mouseleave(function() {
	clearTimeout(timeoutMenu);
});
//MENU MANAGER VISIBILITY
$('.left-menu-sticky').mouseenter(function() {
	$('.category-menu').addClass('on');
});
$('.category-menu').mouseleave(function() {
	$('.category-menu').removeClass('on');
});


//home page scroll manager

if($('.manager_home').length != 0){
	//alert('NOT Mobile');
	$('#homeIndicators a').click(function(){
		$('html,body').animate({
    	scrollTop: $($(this).attr('href')).offset().top
  	},800);
		$('#homeIndicators a').removeClass('active');
		$(this).addClass('active');
		$('.main_banner.active').removeClass('active');	
		//console.log($(this).attr('href').replace('#', ''));
		$($(this).attr('href')).addClass('active');
	});
	setTimeout(function(){
		var doneActive=true;
		$('.main_banner').each(function(){
			if($(this).offset().top == $(document).scrollTop()){
				$(this).addClass('active');
				$('#homeIndicators a[href="#'+$(this).attr('id')+'"]').addClass('active');
				 doneActive=false;
			}
		});
		if( doneActive){
			$('.main_banner').first().addClass('active');
			$('#homeIndicators a[href="#'+$('.main_banner').first().attr('id')+'"]').addClass('active');
		}
	},800);
	
	var lastScrollTop = 0;
	var onScrolling=false;
	if( !window.mobileAndTabletCheck()){
		/*
		 $('.manager_home').bind('mousewheel whell DOMMouseScroll', function(e){

			if(!onScrolling){
				//console.log('scroll');

		//console.log(onScrolling);
				onScrolling=true;
				if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
						if (e.originalEvent.detail > 0) {
								//scroll down
							//console.log('scrolling down !');
							var r=scrollToNext();
							setTimeout(function() {
									onScrolling = false;
							}, 1500);
						} else {

							//console.log('scrolling up !');
							var r=scrollToPrev();
							setTimeout(function() {
									onScrolling = false;
							}, 1500);
						}
				} else {
					if(e.originalEvent.wheelDelta  > 0) {
						//console.log('scrolling up !');
						var r=scrollToPrev();
						setTimeout(function() {
								onScrolling = false;
						}, 1500);
					}
					else{
						//console.log('scrolling down !');
						var r=scrollToNext();
						setTimeout(function() {
								onScrolling = false;
						}, 1500);
					}
				}
			}else{
				return false;
			}
		});
		*/
	}

	function scrollToNext(){
		
		var $next;
		$next = $('.main_banner.active').next('.main_banner');
		if($next.length != 0){
			$('.main_banner.active').removeClass('active');		
			$('html,body').stop().animate({ scrollTop: $next.offset().top	}, 1500);
			$next.addClass('active');
			$('#homeIndicators a').removeClass('active');
			$('#homeIndicators a[href="#'+$next.attr('id')+'"]').addClass('active');
		}
		return false;
	}
	function scrollToPrev(){
		var $prev;
		$prev = $('.main_banner.active').prev('.main_banner');
		if($prev.length != 0){
			$('.main_banner.active').removeClass('active');			
			$('html,body').stop().animate({ scrollTop: $prev.offset().top	}, 1500);
			$prev.addClass('active');
			$('#homeIndicators a').removeClass('active');
			$('#homeIndicators a[href="#'+$prev.attr('id')+'"]').addClass('active');
		}
		return false;
		}

	$('[data-zg-scrollTo="next"]').click(function(){
		//console.log('NEXT');
		var r=scrollToNext();
		setTimeout(function() {
				onScrolling = false;
		}, 800);
	});
	if($('.manager_home').length != 0 && !window.mobileAndTabletCheck()){
		/* document.querySelector('body').style.overflow = "hidden";
			document.addEventListener('touchstart', handleTouchStart, false);        
			document.addEventListener('touchmove', handleTouchMove, false);
		*/
	}else{
		document.querySelector('body').style.overflow = "initial";
		$(document).scroll(function(){
			$('.main_banner').each(function(){
				if(isScrolledIntoView($(this))){
					$('#homeIndicators a').removeClass('active');					
					//console.log($(this).attr('id'));
					$('#homeIndicators').find('[href="#'+$(this).attr('id')+'"]').addClass('active');
				}
			});
		});
	}

	var xDown = null;                                                        
	var yDown = null;

	function getTouches(evt) {
		return evt.touches ||             // browser API
					evt.originalEvent.touches; // jQuery
	}                                                     

	function handleTouchStart(evt) {
		if(onScrolling == false && xDown ==null){
			const firstTouch = getTouches(evt)[0];                                      
			xDown = firstTouch.clientX;                                      
			yDown = firstTouch.clientY;     
		}
	};                                                

	function handleTouchMove(evt) {
			if ( ! xDown || ! yDown ) {
					return;
			}
			

			var xUp = evt.touches[0].clientX;                                    
			var yUp = evt.touches[0].clientY;

			var xDiff = xDown - xUp;
			var yDiff = yDown - yUp;


					if ( yDiff > 0 ) {
						/* up swipe */ 					
						//console.log('scroll touch');
							var r=scrollToNext();
							setTimeout(function() {
									onScrolling = false;
									$('html,body').stop();
							}, 1500);

					} else { 
						/* down swipe */
						//console.log('scroll touch');
							var r=scrollToPrev();
							setTimeout(function() {
								onScrolling = false;
								$('html,body').stop();
							}, 1500);



					}                                                                 

			/* reset values */
			xDown = null;
			yDown = null;                                             
	};
}

	//CM INCH SELECTOR
	$(document).on('click','[data-prop-selector]',function(){
		//DESELECT ALL
		$('[data-prop-selector]').removeClass('active');
		//SELECT CLICKED
		$(this).addClass('active');
		//HIDE ALL OPTIONS
		$('[data-prop]').addClass('hidden');
		//SHOW SELECTED OPTION
		$('[data-prop='+$(this).data('prop-selector')+']').removeClass('hidden');
	});
	
	//SIZE SELECTOR
	$(document).on('click','[data-size-selector]',function(){
		//DESELECT ALL
		$('[data-size-selector]').removeClass('active');
		//SELECT CLICKED
		$(this).addClass('active');
		//HIDE ALL OPTIONS
		$('[data-size]').addClass('hidden');
		//SHOW SELECTED OPTION
		$('[data-size='+$(this).data('size-selector')+']').removeClass('hidden');
	});
	
	//HIDE SIZE DISABLED
	$(document).on('sizechart-modal',function(){
		$('#modalSizeChart .right-box [data-size-selector]').addClass('hidden');
		$('#site_main > .product-details [data-option-id="2"] a').each(function(){
			var s=$(this).html().trim();
			//console.log($(this).html().trim());
			$('#modalSizeChart .right-box [data-size-selector="'+s+'"]').removeClass('hidden');
			//$(this).data('size-selector');
		});	
	});
$('.manager_product .left img'   ).on( 'load',function(e){
	$this = $(this);
	setTimeout(function(){
		$this.css({'width' : '100%', 'height' :'auto'});
		$this.css({'width' : $this.innerWidth(), 'height' : $this.innerHeight()});
	},1500);
} );
//FIX FOR double image 
$( document ).ready(function() {
	if($('.double_images').length != 0){
		if($('.double_images').innerHeight() >= $('.double_images').innerWidth()){
			console.log('DOUBLE IMAGE MOBILE');
			$('.double_images .div-left').css('top', '0');
			$('.double_images .div-left').css('bottom', '50%');
			$('.double_images .div-left').css('left', '0');
			$('.double_images .div-left').css('width', '80%');
			
			
			$('.double_images .div-right').css('top', '50%');
			$('.double_images .div-right').css('bottom', '0');
			$('.double_images .div-right').css('width', '80%');
			$('.double_images .div-right').css('right', '0');
			$('.double_images .div-right').css('left', 'auto');
			if(IS_MOBILE){
				$('.double_images .div-left').css('width', '100%');
				$('.double_images .div-right').css('width', '100%');
			}	
		}
	}
})

//flagship-carousel
$( document ).ready(function() {
	if ($('#flagship-carousel').length > 0) {

		var url = window.RANDOM_IMG_ROOT + '/themes/' + window.SGL_JS_MERCHANT_ID + '/' + window.SGL_JS_THEME + '/js/lib/slick.min.js';
		$.getScript( url, function() {
		
			$('#flagship-carousel').slick({
				dots: true,
  				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: true,
				
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});


		});



	
	}
});


$(window).on('load', function() {
	var video = $('.manager_product video.product-video');
	/*console.log('on load -- video', video)*/
	
	if (video.length > 0) {
		video.each(function() {
			this.play();
		})
	}
	/*POPUP HOME*/
	if(zgReadCookie('popup_home') != 1){
		if($('#countrypopUp')){
			$('#countrypopUp').modal("show");
			zgCreateCookie('popup_home','1',1);
		}
	}
});

$( document ).ready(function() {
	if ($('#products-container').length > 0) {
		$( document ).on('mouseover','.product-preview>article.panel', function(){
			$( this ).find('.image-option img').each(function( index ) {
  				$( this ).attr('src', $( this ).data('src') );
			});
		});
	}
});

//newsletter AJAX
$( document ).on('ready', function() {

	/*ontrust trick to change lang*/
	var checkLang=0;
	if($('[data-onetrust-lang="IT"]').length != 0){
		$('[data-onetrust-lang="IT"]').html('Cookie Settings');
		$('[data-onetrust-lang="IT"]').on('DOMSubtreeModified', function(){
			if(checkLang == 0){
				checkLang=1;
				$('[data-onetrust-lang="IT"]').html('Cookie Settings');
				$('[data-onetrust-lang="IT"]').off('DOMSubtreeModified');
			}
		});
	}
	/*NL */
	var forms = $('#newsletter_form_footer, #newsletter_form_component')
	/*console.log('initNl', forms)*/
	
	forms.each(function (index, el) {
		var clearEmailInput = function() {
			$(el).find('input[type="email"]').val('')
		}
		
		var privacyField = $(el).find('input[name="check-footer"], input[name="check-component"]')
		var action = $(this).attr('action')
		
		$(el).on('submit', function(e) {

			e.preventDefault()
			if(privacyField.is(':checked')) {
				if($(el).valid()) {
					var dataArray = $(this).serializeArray()
					var formData = new FormData(this)

					$.ajax({
						url: action,
						type: 'POST',
						cache: false,
						dataType: "html",
						data: $(this).serialize(),
						contentType: 'application/x-www-form-urlencoded',		

						beforeSend: function ( xhr ) {
							xhr.setRequestHeader('X-Requested-With', 'empty');
						},
					})

					.done(function(response, status) {
						var htmlResponse = $(response)
						var alreadyregistered = htmlResponse.find('.user-already-registered').length > 0

						if (alreadyregistered) {
							$.gritter.add( {
								title:      window.JS_TRANSLATIONS['notifier.notification'] || 'Notification',
								class_name: 'alert alert-success',
								text: 	JS_TRANSLATIONS.already_nl_ok.substring( 0, 40 ),
								time: 1000000,
							} );

							clearEmailInput()
						} else {
							$.gritter.add( {
								title:      window.JS_TRANSLATIONS['notifier.notification'] || 'Notification',
								class_name: 'alert alert-success',
								text: 	JS_TRANSLATIONS.nl_email_to_confirm.substring( 0, 40 ),
								time: 1000000,
							} );

							clearEmailInput()
						}
					})

					.error(function (error) {
						console.log('Error', error)
					})
				} else {
					var mailError = $(el).find('#ns_email-error')	
					mailError.css('color', 'red')
					setTimeout(function () {
							mailError.css('color', 'black')
					}, 3000)
				}
			}
		})
	})

})

$(window).on('load', function() {
	var params = new URL(document.location).searchParams;
	var emailConfirmation = params.get("emailConfirmation");
	
	if (!!emailConfirmation) {
		$.gritter.add( {
				title:      window.JS_TRANSLATIONS['notifier.notification'] || 'Notification',
				class_name: 'alert alert-success',
				text: 	JS_TRANSLATIONS.notification_nl_ok.substring( 0, 40 ),
				time: 1000000,
			} );
	}

	$(document).on("click", "#collapseOption2 .btn" , function() {
		$('[data-zg-role="startingfrom"]').hide();
	});


})

$(window).on('load', function() {
	if($('[data-zg-role="countrycost"]').length){
		$( '[data-zg-role="countrycost"]' ).each(function( index ) {
			var $form = $( this );
			$form.on("change", 'select' , function() {
				var $selectedValue = $form.find( 'select option:selected' );
				var shippingCost = $selectedValue.data('shipping');
				var returnCost = $selectedValue.data('return');
				var currency = $selectedValue.data('currency');
				$form.find('[data-zg-role="shipping-fee"]').html(JS_TRANSLATIONS.starting_from + " " + currency + " " + shippingCost);
				$form.find('[data-zg-role="return-fee"]').html(currency + " " + returnCost);
			});
		});
		
	};
});

window.onload = function() {
	/*
	const $opacity0 = document.querySelector('.opacity0');
	if($opacity0){
		$opacity0.style.opacity = '1';
	}
	*/

   //Select all images to be lazy-loaded
   const imgTargets = document.querySelectorAll('.lazy-img');
   
    //Intersection Observer Callback Function
    const loadImg = (entries, observer) => {
		for(const entry of entries){
			if(entry.isIntersecting){
				console.log("intersecting");
				if(entry.target.dataset.src){
					entry.target.src = entry.target.dataset.src;
				}
				else {
					let backgroundPath = entry.target.dataset.background;
					if(screen.orientation.type === 'portrait-primary' && entry.target.dataset.backgroundMobile){
						backgroundPath = entry.target.dataset.backgroundMobile;
					}
					entry.target.style.backgroundImage = `url(${backgroundPath})`;
				}
				entry.target.style.opacity = '1';
				entry.target.classList.remove('height100vh');
				observer.unobserve(entry.target);
			}
		}
    };

   //Create an instance of the IntersectionObserver Object
    const imgObserver = new IntersectionObserver(loadImg,{
        root: null,
        threshold: 0.1,
    })

    //set the images to be observed
    imgTargets.forEach(img => imgObserver.observe(img));
};

// Replacing image source when rotating the viewport
screen.orientation.addEventListener("change", function(e) {
	document.querySelectorAll('.lazy-img').forEach(el => {
		if(el.style.backgroundImage !== '' || el.style.backgroundImageMobile !== ''){
			const backgroundPath = el.dataset.background;
			const backgroundPathMobile = el.dataset.backgroundMobile;
			if(screen.orientation.type === 'portrait-primary'){
				if(backgroundPathMobile){
					el.style.backgroundImage = `url(${backgroundPathMobile})`;
				}
			} else {
				if(backgroundPath){
					el.style.backgroundImage = `url(${backgroundPath})`;
				}
			}
		}
	})
});
$(document).ready(function(){ 
    $('[data-toggle="tooltip"]').tooltip();

	$('[data-zg-role="checklogin"]').click(function(e){
		e.preventDefault();
		e.stopPropagation();
		let $form = $(this).parent('form');
		let action =$form.attr('action')
		/*let data = $form.serializeArray()
		let resultData ={}
		for(var i = 0; i < data.length; i++){

			resultData[data[i].name]= data[i].value
		}
		console.log(resultData,"RESULTDATA : ")

		$.redirect(action, resultData);*/
		let data = $form.serialize()
		location.href=action+'?'+data
	});

});